"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownInput = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../common");
exports.DropDownInput = (0, react_1.forwardRef)(({ title, defaultValue = '', dropdownList, handlerUpdate, buttonStyle = {
    width: '123px',
}, noShowButtonArea = false, buttonOption, noSelectOption, ...props }, ref) => {
    const selectRef = (0, react_1.useRef)(null);
    const [list, setList] = (0, react_1.useState)([]);
    const [value, setValue] = (0, react_1.useState)(defaultValue);
    (0, react_1.useImperativeHandle)(ref, () => ({
        focus: () => selectRef.current?.focus(),
        getValue: () => value,
        setValue: (newValue) => {
            setValue(newValue);
            if (selectRef.current) {
                selectRef.current.value = newValue;
            }
        },
    }));
    const onChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);
        handlerUpdate?.(newValue);
    };
    (0, react_1.useEffect)(() => {
        if (!noSelectOption) {
            setList(dropdownList);
        }
        else if (noSelectOption.show) {
            setList([{ id: noSelectOption.id, value: noSelectOption.title }, ...dropdownList]);
        }
        else {
            setList(dropdownList);
        }
    }, [dropdownList, noSelectOption]);
    (0, react_1.useEffect)(() => {
        setValue(defaultValue);
        if (selectRef.current) {
            selectRef.current.value = defaultValue;
        }
    }, [defaultValue]);
    return (react_1.default.createElement("div", { className: "text-input" },
        react_1.default.createElement("label", { className: "title" }, title),
        react_1.default.createElement("select", { className: "custom-select", ref: selectRef, value: value, onChange: onChange, ...props }, list.map((item, index) => (react_1.default.createElement("option", { key: index, value: item.id }, item.value)))),
        !noShowButtonArea && (react_1.default.createElement("div", { style: buttonStyle }, buttonOption && (react_1.default.createElement(common_1.Button, { className: buttonOption.className, text: buttonOption.title, onClick: buttonOption.handlerClick }))))));
});
